import { IClickEventData } from 'types/analytics';

export const TEXT_KEYS = {
    CAPTION: 'friend-referral-program',
    TITLE: 'invitation-page__title',
    DESCRIPTION: 'invitation-page__description',
    CAMPAIGN_DESCRIPTION: 'invitation-page__campaign-description',
    BUTTON_ACCEPT: 'invitation-page__button-text',
    WARNING: 'invitation-page__warning'
};

export const INVITATION_ANALYTICS = (actionName: string): IClickEventData => ({
    location: 'friend referral',
    category: 'action',
    action: `${actionName}`
});
